// Simple Danish translations - fallback for removed i18n system
const danishTranslations = {
  // Auth
  'auth.welcomeBack': 'Velkommen tilbage',
  'auth.signIn': 'Log ind på din konto',
  'auth.email': 'Email',
  'auth.password': 'Adgangskode', 
  'auth.login': 'Log ind',
  'auth.noAccount': 'Har du ikke en konto?',
  'auth.signUp': 'Opret konto',
  'auth.register': 'Opret konto',
  'auth.firstName': 'Fornavn',
  'auth.lastName': 'Efternavn',
  'auth.phone': 'Telefon',
  'auth.confirmPassword': 'Bekræft adgangskode',
  'auth.alreadyHaveAccount': 'Har du allerede en konto?',
  'auth.dontHaveAccount': 'Har du ikke en konto?',
  'auth.joinTheCrew': 'Bliv en del af crewet',
  'auth.signInButton': 'Log ind',
  'auth.signInLink': 'Log ind her',
  
  // Navigation
  'nav.dashboard': 'Dashboard',
  'nav.browseShifts': 'Vagter',
  'nav.profile': 'Profil',
  'nav.logout': 'Log ud',
  'nav.login': 'Log ind',
  'nav.register': 'Tilmeld dig',
  
  // Dashboard
  'dashboard.welcome': 'Velkommen',
  'dashboard.subtitle': 'Din RUB-Crew portal',
  'dashboard.myShifts': 'Mine Vagter',
  'dashboard.totalShifts': 'Samlede Vagter',
  'dashboard.browseShifts': 'Gennemse Vagter',
  'dashboard.browseMoreShifts': 'Se flere vagter',
  'dashboard.noShifts': 'Ingen vagter endnu',
  'dashboard.noShiftsDesc': 'Du har ikke tilmeldt dig nogen vagter endnu',
  'dashboard.pending': 'Afventer',
  'dashboard.confirmed': 'Bekræftet',
  'dashboard.workplace': 'Arbejdsplads',
  'dashboard.start': 'Start',
  'dashboard.end': 'Slut',
  'dashboard.cancel': 'Aflys',
  'dashboard.cancelConfirm': 'Er du sikker på at du vil aflyse denne vagt?',
  
  // Landing Page
  'landing.title': 'Bliv en del af',
  'landing.subtitle': 'RUB-Crew',
  'landing.description': 'Oplev Danmarks bedste musikfestival indefra som frivillig crew-medlem',
  'landing.applyNow': 'Ansøg nu',
  'landing.alreadyMember': 'Allerede medlem?',
  'landing.whyJoin': 'Hvorfor blive en del af RUB-Crew?',
  'landing.festivalExperience': 'Unik Festival Oplevelse',
  'landing.festivalExperienceDesc': 'Oplev festivalen fra en helt særlig vinkel og vær med til at skabe magien',
  'landing.amazingCommunity': 'Fantastisk Fællesskab',
  'landing.amazingCommunityDesc': 'Bliv en del af et stærkt fællesskab af engagerede frivillige',
  'landing.flexibleShifts': 'Fleksible Vagter',
  'landing.flexibleShiftsDesc': 'Vælg vagter der passer til din tidsplan og interesser',
  'landing.howItWorks': 'Sådan fungerer det',
  'landing.step1': 'Tilmeld dig',
  'landing.step1Desc': 'Opret din profil og fortæl os om dig selv',
  'landing.step2': 'Vælg vagter',
  'landing.step2Desc': 'Browse og ansøg om vagter der interesserer dig',
  'landing.step3': 'Bliv godkendt',
  'landing.step3Desc': 'Vi gennemgår din ansøgning og godkender dig',
  'landing.step4': 'Oplev festivalen',
  'landing.step4Desc': 'Nyd festivalen som en del af crew-teamet',
  'landing.readyToJoin': 'Klar til at blive en del af holdet?',
  'landing.applicationsOpen': 'Ansøgninger er nu åbne for næste festival',
  'landing.applyToVolunteer': 'Ansøg som frivillig',
  
  // Register
  'register.gdprRequired': 'Du skal acceptere GDPR betingelserne for at fortsætte',
  'register.createAccount': 'Opret din konto',
  'register.joinCommunity': 'Bliv en del af RUB-Crew fællesskabet',
  'register.title': 'Opret konto',
  'register.subtitle': 'Bliv en del af RUB-Crew fællesskabet',
  'register.firstName': 'Fornavn',
  'register.lastName': 'Efternavn',
  'register.phone': 'Telefon',
  'register.tshirtSize': 'T-shirt størrelse',
  'register.selectSize': 'Vælg størrelse',
  'register.language': 'Sprog',
  'register.danish': 'Dansk',
  'register.english': 'Engelsk',
  'register.gdprConsent': 'Jeg accepterer behandling af persondata',
  'register.photoConsent': 'Jeg giver tilladelse til brug af fotos',
  'register.createAccountButton': 'Opret konto',
  'register.creating': 'Opretter...',
  
  // Footer
  'footer.quickLinks': 'Hurtige links',
  'footer.about': 'Om os',
  'footer.volunteerFAQ': 'Frivillig FAQ',
  'footer.contact': 'Kontakt',
  'footer.contactInfo': 'Kontakt information',
  'footer.rights': 'Alle rettigheder forbeholdes',
  
  // Common
  'common.loading': 'Indlæser...',
  'common.backToHome': 'Tilbage til forsiden',
  
  // Messages
  'Bruger flyttet til ny gruppe!': 'Bruger flyttet til ny gruppe!',
  'Bruger forfremmet til supervisor!': 'Bruger forfremmet til supervisor!',
  'Du har ikke tilladelse til at impersonere denne bruger': 'Du har ikke tilladelse til at impersonere denne bruger',
  'Failed to cancel shift': 'Kunne ikke aflyse vagt',
  'Failed to export shifts': 'Kunne ikke eksportere vagter',
  'Failed to save group': 'Kunne ikke gemme gruppe',
  'Failed to save shift': 'Kunne ikke gemme vagt',
  'Failed to save workplace': 'Kunne ikke gemme arbejdsplads',
  'Failed to update assignment': 'Kunne ikke opdatere tildeling',
  'Failed to update user': 'Kunne ikke opdatere bruger',
  'Group manager removed successfully': 'Gruppeleder fjernet succesfuldt',
  'Kategori opdateret!': 'Kategori opdateret!',
  'Kategori oprettet!': 'Kategori oprettet!',
  'Kategori slettet!': 'Kategori slettet!',
  'Kunne ikke afslutte impersonering': 'Kunne ikke afslutte impersonering',
  'Kunne ikke slette vagten': 'Kunne ikke slette vagten',
  'Medlem forfremmet til Gruppeleder!': 'Medlem forfremmet til Gruppeleder!',
  'Opslag slettet!': 'Opslag slettet!',
  'Supervisor removed successfully': 'Supervisor fjernet succesfuldt',
};

// Simple translation function
export const t = (key) => {
  return danishTranslations[key] || key;
};

// Hook replacement
export const useLanguage = () => {
  return { t };
};